export default "__VITE_ASSET__DYen97wO__"